export default __webpack_public_path__ + "static/media/notfication.90b69c0d.svg";